'use client';

import { memo, useCallback } from 'react';

import { CheckIcon } from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { useSelectedProviderContext } from '~/contexts/SelectedProviderContext';

export type SAMLProvidersSelectListItemProps = {
  image: string;
  name: string;
  provider: string;
};

export const SAMLProvidersSelectListItem = memo(({ image, name, provider }: SAMLProvidersSelectListItemProps) => {
  const { selectedProvider, setSelectedProvider } = useSelectedProviderContext();

  const handleClick = useCallback(() => {
    setSelectedProvider(provider);
  }, [provider, setSelectedProvider]);

  const isActive = selectedProvider === provider;

  return (
    <button
      className={cn('flex w-full items-center gap-3 rounded-8 p-2', isActive ? 'bg-neutral-4' : 'hover:bg-neutral-3')}
      disabled={!provider}
      onClick={handleClick}
      type="button"
    >
      <div className="size-8 shrink-0 overflow-hidden rounded bg-neutral-3">
        {/* biome-ignore lint/performance/noImgElement: plugin-ui is a shared package, not a Next.js app */}
        <img alt={name} className="size-full object-cover" src={image} />
      </div>

      <span className="flex-1 text-left font-medium text-14 text-neutral-12">{name}</span>
      {isActive && <CheckIcon className="shrink-0 text-brand-9" size="sm" />}
    </button>
  );
});

SAMLProvidersSelectListItem.displayName = 'SAMLProvidersSelectListItem';
